<div class="scroll-shell">
<router-outlet></router-outlet>
</div>
